import React from "react";
import { Delete, CornerDownLeft } from "lucide-react";

const ROWS = [
  ["1", "2", "3", "4", "5"],
  ["6", "7", "8", "9", "0"],
];

function keyClass(state) {
  if (state === "green") return "numex-key-green";
  if (state === "yellow") return "numex-key-yellow";
  return "";
}

export default function Keyboard({ onKey, onDelete, onEnter, keyStates, disabled }) {
  return (
    <div className="flex flex-col gap-1.5 w-full" data-testid="numex-keyboard">
      {ROWS.map((row, i) => (
        <div key={i} className="grid grid-cols-5 gap-1.5">
          {row.map((d) => (
            <button
              key={d}
              type="button"
              disabled={disabled}
              onClick={() => onKey(d)}
              className={`numex-key h-12 sm:h-14 text-lg sm:text-xl ${keyClass(keyStates[d])}`}
              data-testid={`key-${d}`}
              data-state={keyStates[d] || "neutral"}
            >
              {d}
            </button>
          ))}
        </div>
      ))}
      <div className="grid grid-cols-2 gap-1.5">
        <button
          type="button"
          disabled={disabled}
          onClick={onDelete}
          className="numex-key h-12 sm:h-14 flex items-center justify-center gap-2 text-sm tracking-wide"
          data-testid="key-delete"
        >
          <Delete size={18} strokeWidth={2} />
          DELETE
        </button>
        <button
          type="button"
          disabled={disabled}
          onClick={onEnter}
          className="numex-key h-12 sm:h-14 flex items-center justify-center gap-2 text-sm tracking-wide"
          data-testid="key-enter"
        >
          <CornerDownLeft size={18} strokeWidth={2} />
          ENTER
        </button>
      </div>
    </div>
  );
}
